export function BattlefieldLighting() {
  return (
    <>
      <hemisphereLight args={["#c8d8d4", "#081017", 1.15]} />
      <directionalLight
        castShadow
        color="#ffe4ad"
        intensity={2.65}
        position={[-3.8, 8.4, 5.8]}
        shadow-bias={-0.00025}
        shadow-mapSize-height={1024}
        shadow-mapSize-width={1024}
        shadow-camera-bottom={-7}
        shadow-camera-far={24}
        shadow-camera-left={-7}
        shadow-camera-right={7}
        shadow-camera-top={7}
      />
      <pointLight color="#b84858" intensity={9} position={[-5.2, 1.3, 3.8]} distance={10} />
      <pointLight color="#3f91bf" intensity={8} position={[5.2, 1.3, -3.8]} distance={10} />
    </>
  );
}
